import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./testimonial.css";

const testimonials = [
    { id: 1, name: "G.R. Surana", project: "Bungalow Project", review: "First Sky Infra has transformed our vision into reality with an exclusive bungalow in Amjekarai. The construction quality, attention to detail, and stunning garden design exceeded our expectations." },
    { id: 2, name: "Agarwal Gupta", project: "Bungalow Project", review: "They delivered exceptional craftsmanship in building our bungalow. From elegant interiors to flawless construction, every detail was executed to perfection." },
    { id: 3, name: "A.R. Rajender", project: "Tata Consultant Office", review: "Expertly crafted our office space with functionality and modern aesthetics. Their attention to detail and workmanship enhanced our workspace." },
    { id: 4, name: "Yashpal Sharma", project: "Showroom Turnkey Project", review: "Exceptional turnkey solution for our showroom. Quality, efficiency, and attention to detail exceeded expectations." },
    { id: 5, name: "Arul Manohar", project: "Apartment Turnkey Project", review: "Seamless turnkey solution. The team was professional, efficient, and attentive to every detail." },
    { id: 6, name: "Anand Skathi Steel", project: "Industrial Factory Project", review: "Outstanding job in building our home. Construction quality and interior design were exceptional." },
    { id: 7, name: "Gopinath", project: "Residential Apartment Turnkey Project", review: "Exceeded expectations with turnkey solutions. Attention to detail and timely delivery made the process stress-free." },
    { id: 8, name: "A.R. Raghuvan", project: "House Turnkey Project", review: "Turned our dream home into reality with exceptional turnkey solutions and elegant interior design." },
    { id: 9, name: "R.B. Chaudhari", project: "Bungalow Project", review: "From structural excellence to elegant interiors, every aspect was executed flawlessly." },
    { id: 10, name: "R.V.S Chairman", project: "House Project", review: "Delivered an exceptional home with top-notch construction quality and exquisite interior design." },
    { id: 11, name: "Suresh Kumar", project: "Metal Merchant House Project", review: "Incredible job in building our home. Construction quality and design exceeded our expectations." },
    { id: 12, name: "K.C. Bugadiya", project: "Individual House Project", review: "Completely satisfied with their professionalism, quality, and attention to detail." },
    { id: 13, name: "Sujana Industries Private Limited", project: "Office Interior Design", review: "Transformed our office with exceptional interior design and craftsmanship." }
];


export default function Testimonials() {
    const [index, setIndex] = useState(0);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    // Update screen size on resize
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prev) => (prev + (isMobile ? 1 : 2)) % testimonials.length);
        }, 3000);
        return () => clearInterval(interval);
    }, [isMobile]);

    const testimonialsToShow = isMobile
        ? testimonials.slice(index, index + 1)
        : testimonials.slice(index, index + 2);

    return (
        <div className="testimonial-container mt-5">
            <div className="section-title clearfix d-flex flex-column align-items-center">
                <div class="title-header">
                    <h5 style={{ textTransform: "uppercase", color: " #FFA800" }}>testimonial</h5>
                    {/* <h3>New Sky Property & Projects Private Limited (NSPP)</h3> */}
                </div>
                <div className='underline' style={{ width:"8%"}} ></div>
            </div>

            <div className="testimonial-box">
                <AnimatePresence mode="wait">
                    {testimonialsToShow.map((testimonial) => (
                        <motion.div
                            key={testimonial.id}
                            initial={{ opacity: 0, x: 100 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: -50 }}
                            transition={{ duration: 0.5 }}
                            className="testimonial-content"
                        >
                            <p className="testimonial-project">{testimonial.project}</p>
                            <p className="testimonial-text">"{testimonial.review}"</p>
                            <p className="testimonial-name">- {testimonial.name}</p>
                        </motion.div>
                    ))}
                </AnimatePresence>
            </div>

            <div className="testimonial-buttons">
                {Array.from({
                    length: Math.ceil(testimonials.length / (isMobile ? 1 : 2)),
                }).map((_, i) => (
                    <button
                        key={i}
                        className={`testimonial-button1 ${index === i * (isMobile ? 1 : 2) ? "active" : ""}`}
                        onClick={() => setIndex(i * (isMobile ? 1 : 2))}
                    />
                ))}
            </div>
        </div>
    );
}
